import { Server } from 'socket.io';
import { AuthSocket } from '../socket.bootstrap';
import { SocketEvents, TypingPayload } from '@ichat/shared-types';

// Map of room -> Set of typing users (with timeout)
const typingTimers = new Map<string, NodeJS.Timeout>();

export function typingHandler(io: Server, socket: AuthSocket) {
  socket.on(SocketEvents.TYPING_START, ({ channelId, conversationId }: Partial<TypingPayload>) => {
    const room = channelId ? `channel:${channelId}` : `conversation:${conversationId}`;
    const key = `${room}:${socket.userId}`;

    socket.to(room).emit(SocketEvents.TYPING_UPDATE, {
      userId: socket.userId,
      displayName: socket.displayName,
      isTyping: true,
      channelId,
      conversationId,
    });

    // Auto-stop after 5s of no updates
    clearTimeout(typingTimers.get(key));
    typingTimers.set(
      key,
      setTimeout(() => {
        socket.to(room).emit(SocketEvents.TYPING_UPDATE, {
          userId: socket.userId,
          isTyping: false,
          channelId,
          conversationId,
        });
        typingTimers.delete(key);
      }, 5000),
    );
  });

  socket.on(SocketEvents.TYPING_STOP, ({ channelId, conversationId }: Partial<TypingPayload>) => {
    const room = channelId ? `channel:${channelId}` : `conversation:${conversationId}`;
    const key = `${room}:${socket.userId}`;
    clearTimeout(typingTimers.get(key));
    typingTimers.delete(key);
    socket.to(room).emit(SocketEvents.TYPING_UPDATE, { userId: socket.userId, isTyping: false, channelId, conversationId });
  });

  socket.on('disconnect', () => {
    // Clean up all timers for this socket
    for (const [key, timer] of typingTimers.entries()) {
      if (key.includes(socket.userId)) {
        clearTimeout(timer);
        typingTimers.delete(key);
      }
    }
  });
}
